import RatingModal from "./RatingModal";

export default RatingModal;
